export const isRefreshEnabled = state => state.settings.isRefreshEnabled;

export const refreshRate = state => state.settings.refreshRate;

export const isApplicationActive = state => state.settings.isApplicationActive;